export default "__VITE_ASSET__IzmC5ANB__"